export const extractGrid = (grid: string, prefix: string) => {
  // making sure we really do not handle codes including prefix anymore
  // we take the prefix code from config + the regex to match the 12 digits number
  const format = '(?!' + prefix + ')[0-9]{12}$'; //
  const re = new RegExp(format);
  const match = String(grid).match(re);

  if (match) {
    grid = match[0];
  }

  return [prefix, grid];
};
